	<template>
  <div class="parent-container" v-if="_gHlp.isLoading('all')">
    <div class="spinner-container">
      <div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status">
				<span class="sr-only">Loading...</span>
			</div>
    </div>
  </div>
</template>

<style scoped>
.parent-container {
  position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 999999;
	background-color: rgba(0,0,0,0.2);
  /* Add other styling for the parent container if needed */
}
.spinner-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>

<script>
import { mapWritableState ,mapStores, mapActions, mapState } from 'pinia'
import { useCommonStore } from '@/stores/commonStore';

export default {
  name: "loading-widget"
};
</script>
